import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'longCalculationValues',
  props: {
    values: {},
    hasAmount: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const value = computed(() => {
  if (props.values.category === "A") {
    return props.values.value;
  }
  return `${props.values.value} - ${props.values.newValue}`;
});

const amount = computed(() => {
  if (props.values.category === "A") {
    return props.values.valueAmount;
  }
  return `${props.values.valueAmount} - ${props.values.newValueAmount}`;
});

const yearly = computed(() => {
  if (props.values.category === "A") {
    return props.values.valueYearly;
  }
  return `${props.values.valueYearly} - ${props.values.newValueYearly}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", null, _toDisplayString(_ctx.values.category), 1 /* TEXT */),
    _createElementVNode("td", null, _toDisplayString(_ctx.values.description), 1 /* TEXT */),
    _createElementVNode("td", null, _toDisplayString(value.value), 1 /* TEXT */),
    (_ctx.hasAmount)
      ? (_openBlock(), _createElementBlock("td", _hoisted_1, _toDisplayString(amount.value), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_ctx.hasAmount)
      ? (_openBlock(), _createElementBlock("td", _hoisted_2, _toDisplayString(yearly.value), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})